module.exports = __webpack_public_path__ + "images/white_bg1-f52f833102.png";